module.exports = __webpack_public_path__ + "static/media/十周年@2x.75afa304.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_210/images/十周年@2x.png
// module id = 1742
// module chunks = 0